export const width = 419;
export const height = 312;
export default __webpack_public_path__ + "static/1.6a0f5e04.svg";